export const rows = [
  { antes: 'Horas buscando qué ejercicio dar', con: 'Elige una clase estructurada y ajusta sus opciones a tu grupo.' },
  { antes: 'Clases repetitivas y predecibles', con: 'Variedad real. Cada semana diferente.' },
  { antes: 'No saber cómo adaptar para cada alumna', con: 'Una opción más sencilla, una progresión y un criterio para avanzar en cada ficha.' },
  { antes: 'Miedo a cometer errores técnicos', con: 'Errores observables y correcciones concretas.' },
  { antes: 'Alumnas que se van por aburrimiento', con: 'Repertorio para variar con un objetivo y repetir para consolidar.' },
  { antes: 'Inseguridad al cobrar', con: 'Profesionalismo documentado.' },
  { antes: 'Clases sin estructura clara', con: 'Sistema completo y listo para enseñar.' }
];
